const FeedBackConstant = {
  GET_FEEDBACK_LIST_SUCCESS: "GET_FEEDBACK_LIST_SUCCESS",
  GET_FEEDBACK_LIST_FAILURE: "GET_FEEDBACK_LIST_FAILURE",
  SAVE_UPDATE_FEEDBACK_SUCCESS: "SAVE_UPDATE_FEEDBACK_SUCCESS",
  SAVE_UPDATE_FEEDBACK_FAILURE: "SAVE_UPDATE_FEEDBACK_FAILURE",
  DEL_FEEDBACK_SUCCESS: "DEL_FEEDBACK_SUCCESS",
  DEL_FEEDBACK_FAILURE: "DEL_FEEDBACK_FAILURE",
};

export default FeedBackConstant;
